import React, { Fragment, PureComponent } from 'react';
import { Item as ProductItem } from '~/Api/Product';
import { PricedProduct } from '~/Product';
import ProductListsTooltip from '~/ProductListsTooltip';
import Checkbox from '~/UI/Checkbox/Checkbox';

import styles from './styles.less';

type Product = PricedProduct<ProductItem>;
interface Props {
	pricedProduct: Product | null;
	initialChecked: boolean;
	disabled: boolean;
	onChange(product: Product | null, checked: boolean): void;
}

interface State {
	checked: boolean;
}

export default class ProductCheckboxAccessory extends PureComponent<Props, State> {
	static defaultProps = {
		pricedProduct: null,
		initialChecked: false,
		disabled: false,
	};

	state = {
		checked: this.props.initialChecked,
	};

	changed = (checked: boolean) => {
		const { pricedProduct, onChange } = this.props;

		this.setState({ checked });
		onChange(pricedProduct, checked);
	};

	render() {
		const {
			props: { pricedProduct, disabled },
			state: { checked },
		} = this;

		return pricedProduct ? (
			<Fragment>
				<Checkbox
					checked={checked}
					disabled={disabled}
					id={`product-accessory-${pricedProduct.product.id}`}
					name={`product-accessory-${pricedProduct.product.id}`}
					onChange={this.changed}
				/>

				{pricedProduct.item.memberOfLists.length > 0 ? (
					<ProductListsTooltip
						pricedProduct={pricedProduct}
						reference={<div className={styles.accessoryTag}>{pricedProduct.item.memberOfLists.length}</div>}
					/>
				) : null}
			</Fragment>
		) : null;
	}
}
